import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLocation, Link } from "react-router-dom";
import { API_URL } from "../../../config";
import { useNavigate } from "react-router-dom";
import "./ViewProjects.css";

function ViewProjects() {
  const location = useLocation();
  const client = location.state?.client;
  const navigate = useNavigate();
  const clientId = client?._id;
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    if (!clientId) return;
    axios
      .get(`${API_URL}/api/getProjectbyClient/${clientId}`)
      .then((res) => setProjects(res.data))
      .catch((err) => console.error("Error fetching projects:", err));
  }, [clientId]);

  return (
    <div className="vp-page">
      <div className="vp-shell">
        <div className="vp-topbar">
          <button className="vp-back-btn" onClick={() => navigate(-1)}>
            {"<-"} Back
          </button>
        </div>

        <div className="vp-hero">
          <h2 className="vp-title">Projects List</h2>
          <p className="vp-subtitle">
            Client: <span>{client?.leadName || "Unknown"}</span>
          </p>
        </div>

        <div className="vp-table-wrap">
          <div className="table-responsive">
            <table className="table mb-0 vp-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Project Name</th>
                  <th>Department</th>
                  <th>Service</th>
                  <th>Budget</th>
                  <th>Start Date</th>
                  <th>End Date</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {projects.length > 0 ? (
                  projects.map((proj, index) => (
                    <tr key={proj._id}>
                      <td>{index + 1}</td>
                      <td className="vp-project-name">{proj.projectName}</td>
                      <td>{proj.department?.deptName}</td>
                      <td>{proj.service?.serviceName}</td>
                      <td>Rs {proj.price}</td>
                      <td>{new Date(proj.startDate).toLocaleDateString()}</td>
                      <td>{new Date(proj.endDate).toLocaleDateString()}</td>
                      <td>
                        <Link to={`/admin/project/${clientId}/${proj._id}`} className="vp-view-btn">
                          View
                        </Link>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8" className="vp-empty-row">
                      No projects found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ViewProjects;
